import { render, staticRenderFns } from "./EvitarSuspensiones.vue?vue&type=template&id=43e5b006&scoped=true"
import script from "./EvitarSuspensiones.vue?vue&type=script&lang=js"
export * from "./EvitarSuspensiones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43e5b006",
  null
  
)

export default component.exports